import React from 'react';
import { Box, Card, CardContent, Typography, Skeleton } from '@mui/material';
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import { JobsCreatedByDate } from '../../../types/reporting';
import { useTheme } from '@mui/material/styles';

interface JobsCreatedChartProps {
  data?: JobsCreatedByDate[];
  loading?: boolean;
}

const JobsCreatedChart: React.FC<JobsCreatedChartProps> = ({ data, loading = false }) => {
  const theme = useTheme();

  if (loading) {
    return (
      <Card sx={{ height: '100%' }}>
        <CardContent>
          <Skeleton variant="text" width="40%" height={28} />
          <Skeleton variant="rectangular" height={300} sx={{ mt: 2 }} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Jobs Created Over Time
        </Typography>
        <Box sx={{ width: '100%', height: 300 }}>
          <ResponsiveContainer>
            <AreaChart
              data={data || []}
              margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
            >
              <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
              <XAxis
                dataKey="dateLabel"
                tick={{ fontSize: 12, fill: theme.palette.text.secondary }}
                tickLine={{ stroke: theme.palette.divider }}
              />
              <YAxis
                tick={{ fontSize: 12, fill: theme.palette.text.secondary }}
                tickLine={{ stroke: theme.palette.divider }}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: theme.palette.background.paper,
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 4,
                }}
                labelStyle={{ color: theme.palette.text.primary }}
              />
              <Legend />
              <Area
                type="monotone"
                dataKey="jobCount"
                name="Jobs Created"
                stroke={theme.palette.primary.main}
                fill={theme.palette.primary.light}
                fillOpacity={0.3}
                strokeWidth={2}
              />
            </AreaChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
};

export default JobsCreatedChart;
